import breakpoints from './breakpoints'

import intersection from '@converdy/utils/intersection'
import objectMap from '@converdy/utils/object-map'
import objectFilter from '@converdy/utils/object-filter'

export default function splitBreakpoints (styleParser) {
  return function (maybeResponsiveStyle) {
    const intersections = intersection(
      [ ...Object.keys(breakpoints), 'desktop' ],
      Object.keys(maybeResponsiveStyle)
    )

    if (intersections.length !== 0) {
      const responsive = objectMap(
        (style, key) => styleParser(style),
        (style, key) => `@media screen and (max-width: ${breakpoints[key]}px)`
      )(
        objectFilter(
          (value, key) => key !== 'desktop'
        )(
          maybeResponsiveStyle
        )
      )

      return {
        ...styleParser(maybeResponsiveStyle.desktop),
        ...responsive
      }
    }

    return styleParser(maybeResponsiveStyle)
  }
}
